import * as clubApi from "shadow-client/endpoints/clubApi";
import { compose, lifecycle, withProps } from "recompose";
import { connect } from "react-redux";
import { decodeParam } from "react-router-utils";
import { getClub } from "shadow-client/redux/selectors";
import { withRouter } from "react-router-dom";
import ClubName from "./ClubName";

const mapStateToProps = (state, { clubId }) => ({
  club: getClub(state, clubId)
});

function componentWillMount() {
  const { clubId, fetchClub } = this.props;

  fetchClub(clubId);
}

export default compose(
  withRouter,
  withProps(({ match }) => ({
    clubId: decodeParam(match.params.clubId)
  })),
  connect(mapStateToProps, { fetchClub: clubApi.fetchClub }),
  lifecycle({ componentWillMount })
)(ClubName);



// WEBPACK FOOTER //
// ./src/app/components/CurrentClub/ClubName/ClubNameContainer.js